enum EEnvironmentVariables {
  VITE_ENV = 'VITE_ENV',
  VITE_CHATBOT_AGENT_ID = 'VITE_CHATBOT_AGENT_ID',
  VITE_HOTJAR_ID = 'VITE_HOTJAR_ID',
  VITE_PARTNER_SERVICE = 'VITE_PARTNER_SERVICE',
  VITE_STRIPE_PUBLIC_KEY = 'VITE_STRIPE_PUBLIC_KEY',
  VITE_OIDC_NAME = 'VITE_OIDC_NAME',
  VITE_VIRTUAL_GURUS_OIDC_END_SESSION_URL = 'VITE_VIRTUAL_GURUS_OIDC_END_SESSION_URL',
  VITE_VIRTUAL_GURUS_OIDC_REGISTER_URL = 'VITE_VIRTUAL_GURUS_OIDC_REGISTER_URL',
  VITE_IS_CAMPAIGNS_ENABLED = 'VITE_IS_CAMPAIGNS_ENABLED',
  VITE_CAMPAIGN_SERVICE = 'VITE_CAMPAIGN_SERVICE',
  VITE_IS_MULTIAGENT_ENABLED = 'VITE_IS_MULTIAGENT_ENABLED',
  VITE_IS_SCENARIOS_ENABLED = 'VITE_IS_SCENARIOS_ENABLED',
  VITE_SCENARIO_SERVICE = 'VITE_SCENARIO_SERVICE',
  VITE_GTM_CONTAINER_ID = 'VITE_GTM_CONTAINER_ID',
  VITE_PHONE_SERVICE_TOKEN = 'VITE_PHONE_SERVICE_TOKEN',
  VITE_ONBOARDING_STATUS = 'VITE_ONBOARDING_STATUS',
  VITE_IS_LIVE_TRANSFERS_ENABLED = 'VITE_IS_LIVE_TRANSFERS_ENABLED',
  VITE_IS_ESCALATIONS_UNDER_CONSTRUCTION = 'VITE_IS_ESCALATIONS_UNDER_CONSTRUCTION',
  VITE_IS_LIVE_TRANSFERS_MIGRATION_COMPLETE = 'VITE_IS_LIVE_TRANSFERS_MIGRATION_COMPLETE',
  VITE_SENTRY_DSN = 'VITE_SENTRY_DSN',
  SENTRY_AUTH_TOKEN = 'SENTRY_AUTH_TOKEN',
  VITE_ENABLE_OFU_CAMPAIGNS = 'VITE_ENABLE_OFU_CAMPAIGNS',
  VITE_AGENT_SERVICE = 'VITE_AGENT_SERVICE',
}

export default EEnvironmentVariables
